import { ref } from 'vue';
import { $api } from '@/services';

const error = ref(null);
const loading = ref(false);

export async function updateDayCareClass(id: string, data: any) {
	error.value = null;
	try {
		const res = await $api.boarding.updateDayCareClass(id, data);
		return res?.data;
	} catch (err) {
		error.value = err?.response?.data?.errors || err.message;
	} finally {
		loading.value = false;
	}
}

export function useUpdateBoarding() {
	return { updateDayCareClass__error: error, loading, updateDayCareClass };
}
